import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env['VITE_SENTRY_DSN'],
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  /**
   * Enriquece TODOS os eventos com tag do establishment atual.
   * Diferente de tags por-evento (setTag local), esta tag é global e barata,
   * útil para filtrar erros no painel por condomínio.
   */
  beforeSend(event) {
    if (typeof window !== 'undefined') {
      try {
        const establishmentId = localStorage.getItem('mep_current_establishment');
        if (establishmentId) {
          event.tags = { ...event.tags, establishment_id: establishmentId };
        }
      } catch {
        // localStorage indisponível: ignora silenciosamente
      }
    }
    return event;
  },
});
